export default "__VITE_ASSET__Bbv8qOI9__"